<template>
  <div>
    <div
      class="slide-control slide-arrow-left"
      v-show="prevSlideArrowVisible"
      @click="prevSlide()"
    >
      <i class="fas fa-chevron-left" />
    </div>
    <div
      class="slide-control slide-arrow-right"
      v-show="nextSlideArrowVisible"
      @click="nextSlide()"
    >
      <i class="fas fa-chevron-right" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      isScreenCapture: (state) => state.isScreenCapture,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters(['isPresenting']),
    hasPrevSlide() {
      return this.$store.getters.currentSlideIndex > 0
    },
    hasNextSlide() {
      return this.presentation.slides && (
        this.$store.getters.currentSlideIndex <
        this.presentation.slides.length - 1
      )
    },
    prevSlideArrowVisible() {
      return this.hasPrevSlide && this.isPresenting && !this.isScreenCapture
    },
    nextSlideArrowVisible() {
      return this.hasNextSlide && this.isPresenting && !this.isScreenCapture
    },
  },
  methods: {
    prevSlide() {
      this.$emit('selectPrevSlide', 'icon-arrow-left')
    },

    nextSlide() {
      this.$emit('selectNextSlide', 'icon-arrow-right')
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-control {
  position: absolute;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
  font-size: 32px;
  z-index: 30;
}
.slide-arrow-right {
  top: 50%;
  right: 1%;
}

.slide-arrow-left {
  top: 50%;
  left: 1%;
}

</style>
